import React from 'react';
import i18n from '../../utilities/i18n';
import { HStack, Button, IconCheck } from '@adc/parallax-component-library';

interface TableSelectionActionsProps {
  enableSelection: boolean;
  isEveryVisibleRowSelected: boolean;
  onBatchSelectButtonPress: () => void;
  rowDataLength: number;
  selectionActions?: React.ReactNode;
}

export const TableSelectionActions: React.FC<TableSelectionActionsProps> = ({
  enableSelection,
  isEveryVisibleRowSelected,
  onBatchSelectButtonPress,
  rowDataLength,
  selectionActions,
}) => {
  if (!enableSelection) {
    return null;
  }

  return (
    <HStack gap={'$2'} alignItems="center">
      <Button
        testID="table-selection-toggle-button"
        variant="secondary"
        size="medium"
        label={
          isEveryVisibleRowSelected
            ? i18n.t('Common.deselectAll')
            : i18n.t('Common.selectAll')
        }
        iconStart={<IconCheck />}
        onPress={onBatchSelectButtonPress}
        disabled={rowDataLength === 0}
      />
      {selectionActions}
    </HStack>
  );
};
